import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trophy, Lock, Star } from "lucide-react";
import { handsBadges } from "@/lib/handsApi";

export default function HandsBadges() {
  const [data, setData] = useState(null);
  useEffect(() => { handsBadges().then(setData).catch(() => toast.error("Couldn't load badges")); }, []);
  if (!data) return <div className="py-16 text-center text-white/40">Loading badges…</div>;
  return (
    <div data-testid="hands-badges" className="pb-6 space-y-4">
      <section className="rounded-3xl bg-gradient-to-br from-[#F59E0B]/25 via-[#0F2118] to-[#0A1512] border border-[#F59E0B]/30 p-5">
        <div className="inline-flex items-center gap-1.5 bg-white/10 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest mb-2"><Trophy className="w-3 h-3 text-[#F59E0B]" /> Milestones</div>
        <div className="font-black text-2xl">Your money badges.</div>
        <div className="text-white/60 text-sm mt-1">{data.unlocked_count} of {data.total} unlocked</div>
      </section>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {data.badges.map((b) => (
          <div key={b.id} data-testid={`badge-${b.id}`}
            className={"rounded-2xl border p-4 " + (b.unlocked ? "bg-gradient-to-br from-[#F59E0B]/15 to-[#0F2118] border-[#F59E0B]/40" : "bg-[#0F2118] border-[#1D3A2E]")}>
            <div className={"w-10 h-10 rounded-full flex items-center justify-center mb-2 " + (b.unlocked ? "bg-[#F59E0B] text-[#0A1512]" : "bg-white/5 text-white/30 border border-white/10")}>
              {b.unlocked ? <Star className="w-5 h-5" fill="currentColor" /> : <Lock className="w-4 h-4" />}
            </div>
            <div className="font-black text-sm">{b.title}</div>
            <div className="text-[11px] text-white/60">{b.desc}</div>
            <div className="mt-2 h-1.5 rounded-full bg-white/5 overflow-hidden">
              <div className={"h-full " + (b.unlocked ? "bg-[#F59E0B]" : "bg-[#22C55E]")} style={{ width: `${b.progress_pct}%` }} />
            </div>
            <div className="text-[10px] text-white/40 mt-1">{b.current} / {b.goal}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
